import { Component, HostListener, Input } from '@angular/core';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'ic-builder-ismain-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent {
  title = 'Intersoft 1';
  height: string;
  @Input()
  public cid: number;
  @Input()
  public form: string;
  routingcounter: number;

  // deferredPrompt: any;
  // showButton = false;

  // @HostListener('window:beforeinstallprompt', ['$event'])
  // onbeforeinstallprompt(e) {
  //   console.log(e);
  //   // Prevent Chrome 67 and earlier from automatically showing the prompt
  //   e.preventDefault();
  //   // Stash the event so it can be triggered later.
  //   this.deferredPrompt = e;
  //   this.showButton = true;
  // }

  constructor( private readonly titleService: Title) {
    this.height = '100vh';
    this.titleService.setTitle('Intersoft One '+document.location.host);
  }

  // addToHomeScreen() {
  //   // hide our user interface that shows our A2HS button
  //   this.showButton = false;
  //   // Show the prompt
  //   this.deferredPrompt.prompt();
  //   // Wait for the user to respond to the prompt
  //   this.deferredPrompt.userChoice.then((choiceResult) => {
  //     if (choiceResult.outcome === 'accepted') {
  //       console.log('User accepted the A2HS prompt');
  //     } else {
  //       console.log('User dismissed the A2HS prompt');
  //     }
  //     this.deferredPrompt = null;
  //   });
  // }
}
